import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useAssignmentsStore = defineStore('assignments', {
  state,
  getters,
  actions
})

export default useAssignmentsStore
